(function ($) {



	/***
	 * Provides item metadata for group (Slick.Group) and totals (Slick.Totals) rows produced by the DataView.
	 * This metadata overrides the default behavior and formatting of those rows so that they appear and function
	 * correctly when processed by the grid.
	 *
	 * This class also acts as a grid plugin providing event handlers to expand & collapse groups.
	 * If "grid.registerPlugin(...)" is not called, expand & collapse will not work.
	 *
	 * @class GroupItemMetadataProvider
	 * @module Data
	 * @namespace Slick.Custom.Data
	 * @constructor
	 * @param inputOptions
	 */
	function ItemMetadataProvider(inputOptions) {
		var _grid;
		var _defaults = {
			cellCssClass: "slick-custom-item-cell",
			rowCssClass: "slick-custom-item-row",
			cellFormatter: defaultCellFormatter,
			rowFocusable: false,
			focusable: false
		};

		var options = $.extend(true, {}, _defaults, inputOptions);

		function getOptions() {
			return options;
		}

		function setOptions(inputOptions) {
			$.extend(true, options, inputOptions);
		}

		function defaultCellFormatter(row, cell, value, columnDef, item, grid) {
			return '';
		}


		function init(grid) {
			_grid = grid;
			_grid.onClick.subscribe(handleGridClick);
			_grid.onKeyDown.subscribe(handleGridKeyDown);

		}

		function destroy() {
			if (_grid) {
				_grid.onClick.unsubscribe(handleGridClick);
				_grid.onKeyDown.unsubscribe(handleGridKeyDown);
			}
		}

		function handleGridClick(e, args) {

		}

		// TODO:  add -/+ handling
		function handleGridKeyDown(e, args) {

		}

		function getRowMetadata(item) {
			var groupLevel = item && item.group && item.group.level;

			return {
				selectable: options.rowSelectable,
				focusable: options.rowFocusable,
				cssClasses: options.rowCssClass + ' slick-group-level-' + groupLevel,
				formatter: options.cellFormatter,
				columns: !!options.columns ? options.columns : null,
				editor: null
			};
		}

		return {
			"init": init,
			"destroy": destroy,
			"getRowMetadata": getRowMetadata,
			"getOptions": getOptions,
			"setOptions": setOptions
		};
	}
	$.extend(true, window, {
		Slick: {
			Custom: {
				Data: {
					ItemMetadata: ItemMetadataProvider
				}
			}
		}
	});
})(jQuery);
